module.exports = __webpack_public_path__ + "static/media/so-algo-duck1.b846759b.jpg";